module.exports = __webpack_public_path__ + "img/ic_clear_filter.f7114080.svg";